











import { Component, Mixins } from "vue-property-decorator";
import { ModelEditableMixin } from "../../../../../base/components/system";
import { ITooltipBehavior } from "../../../../domain/format/objects";
import { default as OptionalFeatureEditor } from "./OptionalFeatureEditor.vue";

@Component({
  components: {
    OptionalFeatureEditor,
  },
})
export default class TooltipBehaviorEditor extends Mixins(ModelEditableMixin) {
  // ModelEditableMixinと同時に使う事.ModelEditableMixin利用APIの宣言.
  writePropertyWhenValid: (writer: (source: ITooltipBehavior) => void) => void;
  readPropertyOrDefault: <T>(reader: (source: ITooltipBehavior) => T, defaultValue: T) => T;

  $refs!: {
    input: HTMLInputElement;
  };

  get isEnable(): boolean {
    return this.readPropertyOrDefault(s => s.isEnable, false);
  }

  get message(): string {
    return this.readPropertyOrDefault(s => s.message, "");
  }

  set message(value: string) {
    this.writePropertyWhenValid(s => s.message = value);
  }
}
